import { bl_fi_mst_coupon_event_RowClass } from "../../../dbschema/bl_fi_mst_coupon_event.model";
import { BaseContainerModel } from "../../base-container.model";

export class CouponEventContainerModel extends BaseContainerModel {
  bl_fi_mst_coupon_event: bl_fi_mst_coupon_event_RowClass =
    new bl_fi_mst_coupon_event_RowClass();
}
